import { auth, db, storage } from '@/firebase'
import { SocialType } from '@/types/user'
import { updateProfile, updateEmail } from 'firebase/auth'
import {
  setDoc,
  doc,
  getDoc,
  serverTimestamp,
  updateDoc,
  collection,
  getDocs,
  DocumentData,
  onSnapshot,
  addDoc,
  writeBatch,
  where,
  limit,
  startAfter,
  query,
  orderBy,
  startAt,
} from 'firebase/firestore'
import { uploadString, ref, getDownloadURL } from 'firebase/storage'
import { SetStateAction } from 'react'

export const createSocialDb = async (id: string, name: string) => {
  const docRef = doc(db, 'social', id)
  const docSnap = await getDoc(docRef)
  try {
    if (docSnap.exists()) {
      return
    } else {
      await setDoc(doc(db, 'social', id), {
        id,
        name,
        photoURL: null,
        follow: [],
        follower: [],
      })
    }
  } catch (error) {
    return error
  }
}

export const uploadUserIcon = async (
  image: string,
  successCb: () => void,
  errCb: () => void,
) => {
  try {
    const storageRef = ref(
      storage,
      `/users/${auth.currentUser.uid}/icon/icon.jpeg`,
    )
    const uploadTask = await uploadString(storageRef, image, 'data_url', {
      contentType: 'image/jpeg',
    })
    const photoURL = await getDownloadURL(uploadTask.ref)
    updateProfile(auth.currentUser, { photoURL })
    updateDoc(doc(db, 'social', auth.currentUser.uid), {
      photoURL,
    })
    successCb()
  } catch (error) {
    console.log(error)
    errCb()
  }
}

export const getUserIcon = async (userId: string) => {
  try {
    const docRef = doc(db, 'social', userId)
    const snapShot = await getDoc(docRef)
    const photoURL = snapShot.data().photoURL
    return photoURL
  } catch (error) {
    console.log(error)
  }
}

export const getMySocialProfile = async () => {
  try {
    const docRef = doc(db, 'social', auth.currentUser.uid)
    const snapShot = await getDoc(docRef)
    const socialProfile = snapShot.data()
    return socialProfile
  } catch (error) {
    console.log(error)
  }
}

export const getSocialProfile = async (userId: string) => {
  try {
    const docRef = doc(db, 'social', userId)
    const snapShot = await getDoc(docRef)
    const socialProfile = snapShot.data()
    return socialProfile
  } catch (error) {
    console.log(error)
  }
}

export const listenSocialProfile = (
  userId: string,
  setState: SetStateAction<any>,
) => {
  try {
    const docRef = doc(db, 'social', userId)
    const unSub = onSnapshot(docRef, (snapshot) => {
      const profile = snapshot.data()
      setState(profile)
    })
    return unSub
  } catch (error) {
    console.log(error)
  }
}

export const getAllUsers = async () => {
  try {
    const ref = collection(db, 'social')
    const usersSnapshot = await getDocs(ref)
    const users = usersSnapshot.docs.map((user) => user.data())
    return users
  } catch (error) {
    console.log(error)
  }
}

export const getFollowList = async (followList: string, name: string) => {
  try {
    const ref = collection(db, 'social')
    const q =
      name.length !== 0
        ? query(
            ref,
            where('id', 'in', followList),
            orderBy('name', 'desc'),
            limit(10),
            startAfter(name),
          )
        : query(
            ref,
            where('id', 'in', followList),
            orderBy('name', 'desc'),
            limit(10),
          )
    const snapShot = await getDocs(q)
    const list = snapShot.docs.map((doc) => doc.data())
    return list
  } catch (error) {
    console.log(error)
  }
}

export const listenAllUsers = (setState: SetStateAction<any>) => {
  try {
    const ref = collection(db, 'social')
    const unSub = onSnapshot(ref, (snapshot) => {
      const users = snapshot.docs.map((document) => ({ ...document.data() }))
      setState(users)
    })
    return unSub
  } catch (error) {
    console.log(error)
  }
}

export const followToggle = async (
  targetUserId: string,
  mySocial: SocialType,
  userSocial: SocialType,
) => {
  try {
    const ref = doc(db, 'social', auth.currentUser.uid)
    const targetRef = doc(db, 'social', targetUserId)
    const followList = mySocial.follow
    const followerList = userSocial.follower
    const isFollowed = followList.includes(targetUserId)
    if (!isFollowed) {
      await updateDoc(ref, { follow: [...followList, targetUserId] })
      await updateDoc(targetRef, {
        follower: [...followerList, auth.currentUser.uid],
      })
    } else {
      await updateDoc(ref, {
        follow: [...followList].filter((item) => item !== targetUserId),
      })
      await updateDoc(targetRef, {
        follower: [...followerList].filter(
          (item) => item !== auth.currentUser.uid,
        ),
      })
    }
  } catch (error) {
    console.log(error)
  }
}

// export const setAllSocials = async () => {
//   const ref = collection(db, 'users')
//   try {
//     const usersSnapshot = await getDocs(ref)
//     const users = usersSnapshot.docs.map((user) => {
//       const data = user.data()
//       return data
//       // return {
//       //   name: data.name,
//       //   id: data.id,
//       //   photoURL: data.photoURL ? data.photoURL : null,
//       //   follow: [],
//       //   follower: [],
//       // }
//     })
//     users.forEach(async (user) => {
//       // await setDoc(doc(db, 'social', user.id), user)
//       const collectionRef = collection(db, 'users', user.id, 'logs')
//       const logsSnap = await getDocs(collectionRef)
//       const logs = logsSnap.docs
//       logs.forEach(async (log) => {
//         const data = log.data()
//         const autoId = doc(collection(db, 'logs')).id
//         setDoc(doc(db, 'logs', autoId), {
//           ...data,
//           shopId: data.id,
//           userId: user.id,
//           id: autoId,
//         })
//         setDoc(doc(db, 'social', user.id, 'logs', autoId), {
//           ...data,
//           shopId: data.id,
//           userId: user.id,
//           id: autoId,
//         })
//       })
//     })
//   } catch (error) {
//     console.log(error)
//   }
// }
